/**
 * Helpers for mission `task.attachedDocs` entries.
 *
 * Entries carry `{ docId, title?, icon? }`. Title/icon are snapshotted when
 * attaching (and refreshed when a doc is binned) so a later permanent delete or
 * TTL expiry can still show "How to make an egg — Deleted" on the mission.
 */

export function makeAttachedDocEntry(doc) {
  if (!doc?.id) return null;
  return {
    docId: doc.id,
    title: (doc.title || '').trim() || 'Untitled Doc',
    icon: doc.icon || '📄',
  };
}

/** Live library metadata wins when the doc still exists. */
export function resolveAttachedDocTitle(entry, meta) {
  if (meta?.title) return (meta.title || '').trim() || 'Untitled Doc';
  if (entry?.title) return (entry.title || '').trim() || 'Untitled Doc';
  return 'Untitled Doc';
}

export function resolveAttachedDocIcon(entry, meta) {
  return meta?.icon || entry?.icon || '📄';
}

/** Doc record is gone (permanent delete or TTL) — show the retained name + "Deleted". */
export function isAttachedDocPermanentlyGone(entry, meta, libraryLoading) {
  return !libraryLoading && !meta;
}

/** Only wait on the library when we have no live doc and no snapshotted title. */
export function isAttachedDocNamePending(entry, meta, libraryLoading) {
  if (meta) return false;
  if (entry?.title) return false;
  return !!libraryLoading;
}

export function formatPermanentlyDeletedLabel(entry, meta) {
  return `${resolveAttachedDocTitle(entry, meta)} — Deleted`;
}
